!function(){"use strict";class t extends HTMLElement{constructor(){super(),this.section=this.closest("product-info"),this.form=this.section&&this.section.querySelector("[data-product-form]"),this.formWrapper=theme.settings.productPageSticky&&this.section?this.section.querySelector("[data-form-wrapper]")||this.form:this.form,this.handleProductAddError=this.handleProductAddError.bind(this),this.boundToggleCartBarOnScroll=this.toggleCartBarOnScroll.bind(this),this.boundSetCartBarHeight=this.setCartBarHeight.bind(this)}connectedCallback(){this.setCartBarHeight(),this.addEventListener("click",this.handleClick.bind(this)),document.addEventListener("theme:scroll",this.boundToggleCartBarOnScroll),document.addEventListener("theme:resize",this.boundSetCartBarHeight),document.addEventListener("theme:product:add-error",this.handleProductAddError)}handleClick(t){const e=t.target.closest("[data-cart-bar-add-to-cart]");e&&this.form&&(t.preventDefault(),e.classList.add("is-loading"),e.setAttribute("disabled","disabled"),this.form.closest("product-form").onSubmitHandler(t));t.target.closest("[data-cart-bar-scroll]")&&(t.preventDefault(),this.scrollToTop())}handleProductAddError(){this.querySelector("[data-cart-bar-add-to-cart]")&&this.scrollToTop()}scrollToTop(){if(!this.section)return;const t=this.section.querySelector("variant-selects"),e=(theme.isMobile?t||this.form:this.section).getBoundingClientRect().top;window.theme.scrollTo(theme.isMobile?e-10:e)}toggleCartBarOnScroll(){const t=window.scrollY;if(this.formWrapper){const e=t>this.formWrapper.offsetTop+this.formWrapper.offsetHeight;this.classList.toggle("is-visible",e)}}setCartBarHeight(){const t=this.offsetHeight;document.documentElement.style.setProperty("--cart-bar-height",`${t}px`)}disconnectedCallback(){document.removeEventListener("theme:product:add-error",this.handleProductAddError),document.removeEventListener("theme:scroll",this.boundToggleCartBarOnScroll),document.removeEventListener("theme:resize",this.boundSetCartBarHeight)}}customElements.get("cart-bar")||customElements.define("cart-bar",t)}();

(function () {
  if (window.BMCartProgressInitialized) return;
  window.BMCartProgressInitialized = true;

  const selectors = {
    wrapper: '[data-cart-progress-wrapper]',
    fill: '[data-cart-progress-fill]',
    text: '[data-cart-progress-text]'
  };

  function formatMoneyDKK(cents) {
    const amount = cents / 100;
    return new Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: 'DKK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Kunne ikke hente kurven');
    }

    return await response.json();
  }

  function updateProgressBars(cart) {
    const wrappers = document.querySelectorAll(selectors.wrapper);
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      const threshold = parseInt(wrapper.dataset.threshold || '49900', 10);
      const fill = wrapper.querySelector(selectors.fill);
      const text = wrapper.querySelector(selectors.text);

      const total = cart.total_price || 0;
      const remaining = Math.max(threshold - total, 0);
      const percentage = Math.min((total / threshold) * 100, 100);

      if (fill) {
        requestAnimationFrame(() => {
          fill.style.width = percentage + '%';
        });
      }

      if (text) {
        if (total >= threshold) {
          text.innerHTML = 'Tillykke! Dit GRATIS Tennis smykkesæt er låst op 🎁';
        } else {
          text.innerHTML =
            'Kun <span data-cart-progress-remaining>' +
            formatMoneyDKK(remaining) +
            '</span> fra dit GRATIS Tennis smykkesæt (3 dele) 🎁';
        }
      }
    });
  }

  async function refreshProgressBar() {
    try {
      const cart = await getCart();
      updateProgressBars(cart);
    } catch (error) {
      console.error('Cart progress error:', error);
    }
  }

  function interceptFetch() {
    if (window.BMCartProgressFetchIntercepted) return;
    window.BMCartProgressFetchIntercepted = true;

    const originalFetch = window.fetch;

    window.fetch = async function () {
      const response = await originalFetch.apply(this, arguments);

      try {
        const request = arguments[0];
        const url = typeof request === 'string' ? request : request && request.url ? request.url : '';

        if (
          url &&
          (
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear')
          )
        ) {
          setTimeout(refreshProgressBar, 150);
          setTimeout(refreshProgressBar, 400);
        }
      } catch (e) {
        console.error(e);
      }

      return response;
    };
  }

  function bindCartEvents() {
    document.addEventListener('DOMContentLoaded', function () {
      refreshProgressBar();
      interceptFetch();
    });

    document.addEventListener('cart:updated', refreshProgressBar);
    document.addEventListener('quantity:updated', refreshProgressBar);
    document.addEventListener('product:added', refreshProgressBar);
    document.addEventListener('theme:cart:change', refreshProgressBar);
    document.addEventListener('theme:product:add', refreshProgressBar);

    document.addEventListener('click', function (event) {
      const target = event.target.closest(
        '[name="plus"], [name="minus"], [data-remove-item], [data-cart-remove], .js-qty__adjust, .cart__remove'
      );

      if (target) {
        setTimeout(refreshProgressBar, 250);
        setTimeout(refreshProgressBar, 500);
      }
    });
  }

  bindCartEvents();
})();